import { IAttachment } from "../../../caseLawDocuments/model/Attachment";
import AttachmentMapper from "../../../caseLawDocuments/service/AttachmentMapper";
import AttachmentParamMapper from "../../../caseLawDocuments/service/AttachmentParamMapper";
import GetAllResourceEntriesInteractor from "../../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../../common/Constants";

export default class GetAllCaseLawDocumentAttachmentsInteractor {
  private resource: GetAllResourceEntriesInteractor<IAttachment>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(caseLawDocumentId: number) {
    return this.resource.execute(
      `${Constants.caseLawDocumentPath}/${caseLawDocumentId}/${Constants.attachmentPath}`,
      AttachmentMapper,
      AttachmentParamMapper
    );
  }
}
